import type { CommonRequestFn } from "@marketplace/http";

import { BASE_MEDIA_URL } from "@/constants";
import { ENDPOINTS } from "@/constants/endpoints";
import { httpClient } from "@/http";
import type {
  RegenerateInvoiceRequestDto,
  RegenerateInvoiceResponseDto
} from "@/types";

type InvoiceServiceContract = {
  regenerateInvoice: CommonRequestFn<
    RegenerateInvoiceRequestDto,
    RegenerateInvoiceResponseDto
  >;
  downloadInvoice: (invoiceUrl: string) => void;
};

export const InvoiceService: InvoiceServiceContract = {
  regenerateInvoice: ({ payload, options }) => {
    const { order_id, handling } = payload;
    const searchParams = handling ? { handling } : {};

    return httpClient
      .post(ENDPOINTS.INVOICE.REGENERATE, {
        ...options,
        json: { order_id },
        searchParams
      })
      .json<RegenerateInvoiceResponseDto>();
  },

  downloadInvoice: (invoiceUrl: string) => {
    // Open the invoice URL in a new tab for download
    window.open(
      `${BASE_MEDIA_URL}/${invoiceUrl}`,
      "_blank",
      "noopener,noreferrer"
    );
  }
};
